import { decryptData } from '../utils/encrypt'
import rol from '../utils/rols'

// sessions opened before role 6 existed carry no `rol`, so they read as false
export const isCoordinator = (state) => state?.rol === rol.coordinatingStaff

export const canAccess = (action, page, state) => {
  const permissions = state?.permissions ? decryptData(state.permissions) : []
  const pageActions = permissions?.find(
    (permission) => permission.id == page
  )?.actions
  if (pageActions?.find((pageAction) => pageAction == action)) {
    return true
  } else {
    return false
  }
}
